<div class="grid-stack-item-content" [ngClass]="{ isDraggable: draggable }">
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">{{ title }}</div>
    <div class="options">
      <button mat-icon-button>
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="grey"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content" lhpeElementLoader #elementLoader="elementloader">
    <div echarts [options]="deliveriesOptions" class="pie-chart"></div>
  </div>
</div>
